import { render, staticRenderFns } from "./FieldSwitch.vue?vue&type=template&id=1631b9ee"
import script from "./FieldSwitch.vue?vue&type=script&lang=js"
export * from "./FieldSwitch.vue?vue&type=script&lang=js"
import style0 from "./FieldSwitch.vue?vue&type=style&index=0&id=1631b9ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports